var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9298 13.93C20.9481 13.93 23.3948 11.4832 23.3948 8.465C23.3948 5.44676 20.9481 3 17.9298 3C14.9116 3 12.4648 5.44676 12.4648 8.465C12.4648 11.4832 14.9116 13.93 17.9298 13.93Z",
    stroke: "#7889B3",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.86 32.1469H7V29.718C7 26.8192 8.15155 24.0391 10.2013 21.9893C12.2511 19.9396 15.0312 18.788 17.93 18.788C20.8288 18.788 23.6089 19.9396 25.6587 21.9893C27.7084 24.0391 28.86 26.8192 28.86 29.718V32.1469Z",
    stroke: "#7889B3",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.50f1cf11cb829f55e6a884a600fb1aa7.svg";
export { ForwardRef as ReactComponent };